export default "__VITE_ASSET__Bmp1MHUC__"